export default __webpack_public_path__ + "static/media/partner22.e01b2357.webp";